var _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMarquise(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60.0188 120L59.4105 119.493C59.0862 119.25 29 94.6782 29 60.517C29 26.3558 59.0659 0.790674 59.4105 0.54739L60.0188 0L60.6675 0.54739C60.9716 0.790674 91.0781 26.5788 91.0781 60.8211C91.0781 95.0634 60.9919 119.25 60.6675 119.493L60.0188 120ZM60.0188 2.67613C55.6599 6.58895 31.0274 30.1267 31.0274 60.517C31.0274 90.9072 55.7207 113.654 60.0188 117.385C64.3371 113.715 89.0101 91.333 89.0101 60.8211C89.0101 30.3092 64.3776 6.6295 60.0188 2.67613Z",
    fill: "#81D8D0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M60.5044 118.824L59.5312 118.581L81.7309 30.3498L64.2145 19.3818L64.7416 18.5303L82.9068 29.8835L82.8055 30.2282L60.5044 118.824Z",
    fill: "#81D8D0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M64.9443 101.713L64.4172 100.841L81.7309 90.6841L59.5312 1.43927L60.5044 1.19598L82.9068 91.1706L64.9443 101.713Z",
    fill: "#81D8D0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M50.2677 108.485L49.4973 107.836L89.3554 60.7197L49.4973 12.1845L50.2677 11.556L90.6935 60.7399L50.2677 108.485Z",
    fill: "#81D8D0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M59.5329 118.824L37.3333 29.8835L55.4985 18.5303L56.0256 19.3818L38.5091 30.3498L60.5061 118.581L59.5329 118.824Z",
    fill: "#81D8D0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M55.4985 101.713L37.3333 90.9884L59.5329 0.993469L60.5061 1.23675L38.5091 90.4816L56.0256 100.841L55.4985 101.713Z",
    fill: "#81D8D0"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M70.1761 108.484L29.5476 60.5371L69.7706 11.5558L70.541 12.1843L30.8857 60.5168L70.9465 107.836L70.1761 108.484Z",
    fill: "#81D8D0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarquise);
export default __webpack_public_path__ + "static/media/Marquise.02e25c6235a50042a461e6648223959e.svg";
export { ForwardRef as ReactComponent };